import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { PageHeader } from '@/components/PageHeader';
import { AssetSettings } from '@/components/Settings/AssetSettings';
import { usePdf } from '@/contexts/PdfContext';
import { searchParam } from '@/utils/router';

const treeSearchSchema = z.object({
  versionId: searchParam().optional(),
});

export const Route = createFileRoute('/$organizationName/pdf/$pdfVersionNodeId/settings/general')({
  component: PDFSettingsGeneralPage,
  validateSearch: treeSearchSchema,
});

function PDFSettingsGeneralPage() {
  const { organizationName } = Route.useParams();
  const { effectiveRole, pdfId } = usePdf();

  const isAssetAdmin = effectiveRole === 'asset_admin';

  return (
    <>
      <PageHeader>PDF Settings</PageHeader>

      <AssetSettings
        showManagePermissionsButton
        assetId={pdfId ?? ''}
        assetName="PDF"
        isAssetAdmin={isAssetAdmin}
        deleteMessage="Once you remove this PDF from Driver, there is no going back. You will need to re-upload the PDF. Please be certain."
        backTo="/$organizationName/library"
        backParams={{ organizationName: organizationName }}
      />
    </>
  );
}
